import React from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(CategoryScale, ArcElement, Tooltip, Legend);

const DonoughtChart = ({ data, isHalf, currency, showLegend}) => {
  const options = {
    responsive: true,
    //   maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    rotation: -90,
    cutout: "70%",
    circumference: isHalf ? 180 : 360,
    plugins: {
      legend: {
        display: showLegend || false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return currency ? `${currency}${Number(value).toFixed(2)}` : value;
          },
        },
      },
    },
  };

  return <Pie data={data} options={options}/>;
};

export default DonoughtChart;
